import { Routes, Route } from "react-router-dom";

// Componentes comuns
import Layout from "../../components/Layout/Layout";
import PrivateRoute from "./PrivateRoute";

import { PATHS } from "../../routes/paths";

// Páginas protegidas
import Home from "../../pages/Home/home";
import Permission from "../../pages/Settings/Permission/Permission";

import Shipping from "../../pages/Documentation/Shipping/Shipping";
import ShippingV1 from "../../pages/Documentation/Shipping/V1/ShippingV1";
import ShippingV2 from "../../pages/Documentation/Shipping/V2/ShippingV2";

import Analysis from "../../pages/Documentation/Analysis/Analysis";
import AnalysisTab from "../../pages/Documentation/Analysis/V1/AnalysisTab/AnalysisTab";
import SolicitacaoAnalisePage from "../../pages/Documentation/Analysis/V2/SolicitacaoAnalisePage";
import Extract from "../../pages/Documentation/Extract/Extract";
import ExtractSindicato from "../../pages/Documentation/Extract/Sindicato/ExtractSindicato";
import ExtractSindicatoDetalhe from "../../pages/Documentation/Extract/Sindicato/ExtractSindicatoDetalhe";
import ComprovantesSindicato from "../../pages/Financeiro/Sindicato/ComprovantesSindicato";

import ManageUsers from "../../pages/ManageUsers/ManageUsers";
import EditUsers from "../../pages/ManageUsers/EditUsers/EditUsers";
import AddUsers from "../../pages/ManageUsers/AddUsers/AddUsers";

import ExtractAnalysis from "../../pages/Documentation/Extract/ExtractAnalysis/ExtractAnalysis";
import BiReport from "../../pages/BiReport/BiReport";
import ExtractModel from "../../pages/Documentation/Extract/ExtractModel/ExtractModel";

import EnvioCompDesp from "../../pages/Financeiro/EnvioCompDespesas/EnvioCompDesp";
import ConferenciaCompDespesas from "../../pages/Financeiro/ConferenciaCompDespesas/ConferenciaCompDespesas";

import PaymentTable from "../../pages/Financeiro/Payment";

import Pagamento from "../../pages/Payment/Pagamento/Pagamento";
import PaymentT from "../../pages/Payment/Payment";

const Payment = PaymentT;

function ProtectedRoutes() {
  return (
    <Routes>
      {/* HOME - todos */}
      <Route
        element={
          <PrivateRoute
            requiredpermission={[
              "Analista",
              "Administrador TI",
              "Administrador",
              "Sindicato",
            ]}
          />
        }
      >
        <Route
          path={PATHS.HOME}
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
      </Route>

      {/* SHIPPING — Administrador TI e Administrador não acessam o Envio, é exclusivo de Sindicato */}
      <Route
        element={
          <PrivateRoute requiredpermission={["Sindicato"]} />
        }
      >
        <Route
          path={PATHS.DOC_SHIPPING}
          element={
            <Layout>
              <Shipping />
            </Layout>
          }
        />

        <Route
          path={PATHS.DOC_SHIPPING_V1}
          element={
            <Layout>
              <ShippingV1 />
            </Layout>
          }
        />

        <Route
          path={PATHS.DOC_SHIPPING_V2}
          element={
            <Layout>
              <ShippingV2 />
            </Layout>
          }
        />
      </Route>

      {/* EnvioCompDesp — Administrador TI e Administrador não acessam, é exclusivo de Sindicato */}
      <Route
        element={
          <PrivateRoute requiredpermission={["Sindicato"]} />
        }
      >
        <Route
          path={PATHS.EXTRACT_ENVIO_COMP}
          element={
            <Layout>
              <EnvioCompDesp />
            </Layout>
          }
        />
      </Route>

      {/* ANALYSIS — apenas analistas e administradores; sindicato adequa no Envio, não analisa aqui */}
      <Route
        element={
          <PrivateRoute
            requiredpermission={[
              "Administrador TI",
              "Administrador",
              "Analista",
            ]}
          />
        }
      >
        <Route
          path={PATHS.DOC_ANALYSIS}
          element={
            <Layout>
              <Analysis />
            </Layout>
          }
        />

        <Route
          path={PATHS.DOC_ANALYSIS_SOLICITACAO}
          element={
            <Layout>
              <SolicitacaoAnalisePage />
            </Layout>
          }
        />

        <Route
          path={PATHS.ANALISE_DETALHE}
          element={
            <Layout>
              <AnalysisTab />
            </Layout>
          }
        />
      </Route>

      <Route
        element={
          <PrivateRoute
            requiredpermission={[
              "Administrador TI",
              "Administrador",
              "Analista",
            ]}
          />
        }
      >
        <Route
          path={PATHS.BI_REPORT_VIEW}
          element={
            <Layout>
              <BiReport />
            </Layout>
          }
        />
      </Route>

      {/* EXTRACT + Financeiro */}
      <Route
        element={
          <PrivateRoute
            requiredpermission={[
              "Administrador TI",
              "Administrador",
              "Analista",
            ]}
          />
        }
      >
        <Route
          path={PATHS.DOC_EXTRACT}
          element={
            <Layout>
              <Extract />
            </Layout>
          }
        />

        <Route
          path={PATHS.EXTRACT_DETALHE}
          element={
            <Layout resolveSindicatoPorResposta>
              <ExtractAnalysis />
            </Layout>
          }
        />

        <Route
          path={PATHS.EXTRACT_PAYMENT_TABLE}
          element={
            <Layout>
              <PaymentTable />
            </Layout>
          }
        />

        <Route
          path={PATHS.EXTRACT_CONF_COMP}
          element={
            <Layout>
              <ConferenciaCompDespesas />
            </Layout>
          }
        />
      </Route>

      {/* EXTRATO — visão sindicato */}
      <Route
        element={
          <PrivateRoute
            requiredpermission={["Sindicato"]}
          />
        }
      >
        <Route
          path={PATHS.EXTRACT_SINDICATO}
          element={
            <Layout>
              <ExtractSindicato />
            </Layout>
          }
        />

        <Route
          path={PATHS.EXTRACT_SINDICATO_DETALHE}
          element={
            <Layout>
              <ExtractSindicatoDetalhe />
            </Layout>
          }
        />

        <Route
          path={PATHS.COMPROVANTES_SINDICATO}
          element={
            <Layout>
              <ComprovantesSindicato />
            </Layout>
          }
        />
      </Route>

      {/* PAYMENT — analistas e administradores */}
      <Route
        element={
          <PrivateRoute
            requiredpermission={[
              "Administrador TI",
              "Administrador",
              "Analista",
            ]}
          />
        }
      >
        <Route
          path={PATHS.PAYMENT_PAGAMENTO}
          element={
            <Layout>
              <Pagamento />
            </Layout>
          }
        />

        <Route
          path={PATHS.PAYMENT_LISTA}
          element={
            <Layout>
              <PaymentT />
            </Layout>
          }
        />

        <Route
          path={PATHS.PAYMENT_ROOT}
          element={
            <Layout>
              <Payment />
            </Layout>
          }
        />
      </Route>

      {/* Outros */}
      <Route element={<PrivateRoute />}>
        <Route
          path={PATHS.SETTINGS_PERMISSION}
          element={
            <Layout>
              <Permission />
            </Layout>
          }
        />

        <Route
          path={PATHS.EXTRACT_MODAL}
          element={
            <Layout resolveSindicatoPorResposta>
              <ExtractModel />
            </Layout>
          }
        />

        <Route
          path={PATHS.MANAGE_USERS}
          element={
            <Layout>
              <ManageUsers />
            </Layout>
          }
        />

        <Route
          path={PATHS.MANAGE_USERS_EDIT}
          element={
            <Layout>
              <EditUsers />
            </Layout>
          }
        />

        <Route
          path={PATHS.MANAGE_USERS_ADD}
          element={
            <Layout>
              <AddUsers />
            </Layout>
          }
        />
      </Route>
    </Routes>
  );
}

export default ProtectedRoutes;